import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {InstrumentedWBLogoLoader} from '../../components/utility/InstrumentedLoader';
import {isSpecificPath} from '../../routes';
import * as PATHS from '../../routes/paths';

const WORKSPACE_LOADING_TEXTS = [
  'Loading project...',
  'Gathering workspace settings...',
  'Loading runs...',
  'Generating visualizations...',
];

export const WorkspaceLoader = () => {
  return (
    <TailwindContents>
      <div
        className={twMerge(
          'fixed left-0 top-0 z-50',
          'flex items-center justify-center',
          'h-[100vh] w-[100vw] bg-[#FAFAFA]'
        )}>
        <InstrumentedWBLogoLoader
          name="workspace-loader"
          loadingTexts={WORKSPACE_LOADING_TEXTS}
        />
      </div>
    </TailwindContents>
  );
};

/**
 * Returns true if path should use WorkspaceLoader as initial loading screen.
 * Includes multi & single run workspaces, and full-screened panels on any workspace.
 * Does not include runs table page.
 */
export function isWorkspaceLoaderPath(path: string): boolean {
  return isSpecificPath(path, [
    ...PATHS.PROJECT_WORKSPACE_PATHS,
    ...PATHS.RUN_WORKSPACE_PATHS,
    ...PATHS.GROUP_WORKSPACE_PATHS,
    ...PATHS.SWEEP_WORKSPACE_PATHS,
  ]);
}
